import React from 'react'

import T from 'T'
import { get } from 'utils/lodash'
import AddressDisplay from 'components/common/address/AddressDisplay'
import LocationActionsColumn from './components/LocationActionsColumn'

export const LOCATION_TABS = {
  ACTIVE: 'active',
  DEACTIVATED: 'deactivated',
}

export const { ACTIVE, DEACTIVATED } = LOCATION_TABS

export const VERTICAL = 'vertical'

export const PLACEHOLDER_TEXTS = {
  NO_LOCATIONS: T.NO_LOCATIONS,
  NO_DEACTIVATED_LOCATIONS: T.NO_DEACTIVATED_LOCATIONS,
}

export const createDataGridColumns = ({ onLocationAnchorElChange, onSelectedLocationForMenuChange, accountId }) => [
  {
    field: 'addressName',
    headerName: T.ADDRESS_NAME,
    flex: 1,
    minWidth: 100,
    filterable: true,
    sortable: true,
    renderCell: params => {
      const location = params.row
      const address = get(location, 'address', {})
      const parcelNumber = get(location, 'parcelNumber', '')

      return <AddressDisplay address={address} parcelNumber={parcelNumber} />
    },
  },
  {
    field: 'fullAddress',
    headerName: T.FULL_ADDRESS,
    filterable: true,
    sortable: true,
    type: 'string',
    valueGetter: (value, row) => row.fullAddress,
  },
  {
    field: 'tags',
    headerName: 'Tags',
    filterable: true,
    sortable: false,
    type: 'string',
    valueGetter: (value, row) => {
      const tags = get(row, 'tags', [])
      return tags.map(tag => get(tag, 'tagName', '')).join(', ')
    },
  },
  {
    field: 'contacts',
    headerName: 'Contacts',
    filterable: true,
    sortable: false,
    type: 'string',
    valueGetter: (value, row) => {
      const contacts = get(row, 'contacts', [])
      return contacts
        .filter(contact => !get(contact, 'deactivated', false))
        .map(contact => {
          const firstName = get(contact, 'firstName', '')
          const lastName = get(contact, 'lastName', '')
          return `${firstName} ${lastName}`.trim()
        })
        .join(', ')
    },
  },
  {
    field: 'actions',
    headerName: '',
    width: 130,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    resizable: false,
    renderCell: params => (
      <LocationActionsColumn
        location={params.row}
        accountId={accountId}
        onLocationAnchorElChange={onLocationAnchorElChange}
        onSelectedLocationForMenuChange={onSelectedLocationForMenuChange}
      />
    ),
  },
]

export const locationsColumnVisibilityModel = () => ({
  addressName: true,
  fullAddress: false,
  tags: false,
  contacts: false,
  actions: true,
})

export const getDataGridStyling = (theme, showColumnHeaders = false) => ({
  border: 'none',
  '& .MuiDataGrid-virtualScroller':{
    pb: 8
  },
  '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
    border: '2px solid transparent',
  },
  '& .MuiDataGrid-row.location-row-selected': {
    backgroundColor: 'background.paper',
    borderColor: `${theme.palette.primary.main}`,
    borderRadius: '4px',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '& .MuiDataGrid-cell': {
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    px: '4px',
  },
  '& .MuiDataGrid-columnHeaders': {
    display: showColumnHeaders ? 'flex' : 'none',
    backgroundColor: theme.palette.background.default,
    borderBottom: showColumnHeaders ? `1px solid ${theme.palette.divider}` : 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.background.default,
    '&:focus-within': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-detailPanel': {
    backgroundColor: theme.palette.background.default,
    overflow: 'hidden !important',
    '& .MuiBox-root': {
      overflow: 'hidden !important',
    },
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-detailPanelToggleCell': {
    padding: '8px',
  },
  '& .MuiDataGrid-detailPanelToggleCell .MuiIconButton-root': {
    color: theme.palette.text.secondary,
  },
})

export const ROW_HEIGHT = 72
